import { Box, Flex, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react'
import { useState } from 'react'
import ReactSelect from 'react-select'
import { useBranches, BranchType } from '@/shared/api/hooks/useBranches'
import { useBranchDispatchContext } from '@/modules/teacher/context/BranchContext'
import { getFromLocalStorage } from '@/shared/utils/localStorageHelper'

const BranchDropdown = () => {
    const [branch, setBranch] = useState(getFromLocalStorage<BranchType>('currentBranch'))

    const dispatch = useBranchDispatchContext()
    const { branches, loading: branchLoading } = useBranches()

    const handleBranchChange = (option: BranchType | null) => {
        if (option) {
            dispatch({
                type: 'set_branch',
                currentBranch: option
            })
            setBranch(option)
        }
    }

    return (
        <>
            <Box borderRadius={4} pt={4}>
                <Flex alignItems="center" gap="2" flexWrap="wrap">
                    <ReactSelect
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                width: '15rem'
                            })
                        }}
                        defaultValue={branch}
                        isLoading={branchLoading}
                        isSearchable
                        placeholder="Select branch"
                        options={branches}
                        onChange={handleBranchChange}
                    />
                </Flex>
                {!branch?.label ? (
                    <Alert status="error" borderRadius={6} my={4} maxW={'fit-content'}>
                        <AlertIcon />
                        <AlertDescription>
                            <strong>No branch selected.</strong> You need to set branch to
                            perform actions on this page
                        </AlertDescription>
                    </Alert>
                ) : null}
            </Box>
        </>
    )
}

export default BranchDropdown
